import { createFileRoute } from '@tanstack/react-router'
import { OrderContractWorkspace, rentalBatchContractSearchSchema } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/service/contracts/batch')({
  validateSearch: rentalBatchContractSearchSchema,
  component: Page
})
function Page() {
  const ids = Route.useSearch().ids
  const { currentSession } = Route.useRouteContext()
  return (
    <OrderContractWorkspace
      key={ids.join(':')}
      ids={ids}
      orderType="service"
      canEdit={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some((permission) =>
          ['contract.document.create', 'contract.document.confirm'].includes(permission)
        )
      }
    />
  )
}
